import { createIcon } from '@chakra-ui/react'

export const ChevronUpIcon = createIcon({
  displayName: 'ChevronUpIcon',
  viewBox: '0 0 16 17',
  path: (
    <path d='M12 10.2158L8 6.21582L4 10.2158' stroke='currentColor' fill='none' strokeWidth='1.75' strokeLinecap='round' strokeLinejoin='round' />
  ),
})
